import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => createStyles({
    marker: {
        position: 'absolute',
        transformOrigin: 'top',
        marginLeft: -30,
        color: '#999',
    },
    markerCircle: {
        width: 60,
        height: 60,
        zIndex: -1,
    },
    markerGeneral: {
        borderRadius: '50%',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
    },
    markerGeneralWithHeading: {
        '&:after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 'calc(100% - 2px)',
            right: 0,
            width: 0,
            height: 0,
            margin: 'auto',
            borderStyle: 'solid',
            borderWidth: '0 7px 10px 7px',
            borderColor: 'transparent transparent currentColor transparent',
        },
    },
    markerCircleGlow: {
        width: 54,
        height: 54,
        '&:after': {
            bottom: 'calc(100% - 1px)',
            color: 'currentColor',
            opacity: 0.3,
        },
        '&:before': {
            content: '""',
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3,
            borderRadius: '50%',
        },
    },
    markerCircleOuter: {
        width: 44,
        height: 44,
        backgroundColor: 'currentColor',
        '&:after': {
            bottom: 'calc(100% - 2px)',
        },
    },
    markerCircleInner: {
        backgroundColor: '#f2f2f2',
        width: 38,
        height: 38,
        '&:after': {
            bottom: 'calc(100% - 3px)',
            color: '#f2f2f2',
        },
    },
    markerCircleInnerActive: {
        backgroundColor: 'currentColor',
        '&:after': {
            color: 'currentColor',
        },
    },
    markerIcon: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: 25,
        height: 25,
        lineHeight: '25px',
        fontSize: 20,
        textAlign: 'center',
        display: 'block',
        zIndex: 15,
        margin: 'auto',
        '& .icon-machine': {
            fontSize: 25,
            color: theme.color.font.dark,
        },
    },
    markerIconActive: {
        color: 'white',
    },
    markerBadge: {
        position: 'absolute',
        top: -12,
        right: -12,
        width: 20,
        height: 20,
        lineHeight: '20px',
        borderRadius: '100%',
        display: 'block',
        color: '#fff',
        textAlign: 'center',
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.bold,
        backgroundColor: theme.color.error.dark,
    },
    markerBadgeSmall: {
        fontSize: 9,
    },
}));
export default useStyles;
//# sourceMappingURL=MapMarkerIconStyles.js.map